import { useState } from 'react';
import { useEffect } from 'react';
import { MOBILE_VIEW_PORT } from '../constants/defaults';

/**
 * @returns Boolen Based of browser viewport
 */
export default function useIsMobile() {
  const getIsMobile = () =>
    typeof window !== 'undefined'
      ? window?.innerWidth <= MOBILE_VIEW_PORT
      : false;
  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const onResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isMobile;
}
